import { type GreetingConditionTypeEnumEnum } from '@/shared/api'

export const GreetingConditionTypeEnum = {
  EveryDay: 1 as GreetingConditionTypeEnumEnum,
  OnDate: 2 as GreetingConditionTypeEnumEnum,
  OnPeriod: 3 as GreetingConditionTypeEnumEnum,
} as const

export type GreetingConditionTypeEnum =
  (typeof GreetingConditionTypeEnum)[keyof typeof GreetingConditionTypeEnum]

export const greetingConditionTypeArray = Object.values(
  GreetingConditionTypeEnum,
)

export const getGreetingConditionTypeString = (
  type: GreetingConditionTypeEnum,
) => {
  switch (type) {
    case GreetingConditionTypeEnum.EveryDay:
      return 'Ежедневно'
    case GreetingConditionTypeEnum.OnDate:
      return 'На дату'
    case GreetingConditionTypeEnum.OnPeriod:
      return 'На период'
    default:
      return 'Неизвестный тип'
  }
}
